// Privacy statement (IDD D-HP-SITE-027, D-HP-SITE-029, D-SAAS-176): every processing with its legal basis and its
// concrete retention, recipients, third-country transfers, rights and the separate right to object. German is the
// authoritative version.
export const privacyPageJA = {
  seo: {
    title: 'プライバシーポリシー | pAIoneer Labs GmbH',
    description: 'paioneer-labs.euにおけるデータ保護に関する情報：サーバーログ、同意、統計、分析、ログインとアプリケーション、お問い合わせ、ダウンロード、法的根拠、保存期間およびお客様の権利。',
    keywords: 'データ保護, プライバシーポリシー, paioneer-labs.eu, Kyveil, Cookie, GDPR',
    url: 'https://paioneer-labs.eu/privacy',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'プライバシーポリシー',
      url: 'https://paioneer-labs.eu/privacy',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'プライバシーポリシー',
    subtitle: 'paioneer-labs.euおよび同サイトで提供するアプリケーションにおける個人データの処理に関する情報です。'
  },
  sections: [
    {
      title: '管理者',
      paragraphs: [
        '本ウェブサイトの管理者は、pAIoneer Labs GmbH（所在地：Prenzlauer Allee 53, 10405 Berlin, ドイツ）であり、代表取締役 Dipl.-Phys. Adrian Eisenmeier および Dr. rer. nat. Nikolai Genov が同社を代表しています。',
        'お問い合わせは、info@paioneer.eu宛てのメールで承ります。提供者に関する完全な情報は、法的表示に記載しています。'
      ]
    },
    {
      title: 'ホスティングと受領者',
      paragraphs: [
        '本ウェブサイトおよびアプリケーションは、pAIoneer Labs GmbHが運用するサーバー上で稼働しており、このサーバーはドイツ・エアフルトにあるKeyweb AGのデータセンターに設置されています。Keyweb AGはサーバーとネットワーク接続を提供し、その際、当社の処理者として業務を行います（一般データ保護規則（GDPR）第28条）。',
        '当社の電子メールのメールボックスは、STRATO AG（ドイツ・ベルリン）が運用しており、当社は同社を通じて電子メールを受信および送信します。STRATO AGはその際、当社のための処理者として活動します（GDPR第28条）。',
        'その他の受領者および第三国への移転については、それぞれの処理の箇所に記載しています。当社はデータを販売せず、データブローカーやソーシャルネットワークのデータと結合することもありません。'
      ]
    },
    {
      title: 'サーバーとログファイル',
      paragraphs: [
        'アクセスのたびに、サーバーはお使いのブラウザが技術的に送信するデータを処理し、ログファイルに保存します。具体的には、IPアドレス、日時、アクセスされたアドレス、参照元ページ（リファラー）、ブラウザの識別情報（ユーザーエージェント）、ステータスコードおよびデータ量です。目的は、ページの配信、運用の安全確保、ならびに攻撃および不正利用の防御です。法的根拠はGDPR第6条第1項(f)です。当社の正当な利益は、ウェブサイトを安全かつ正常に配信することにあります。ログファイルは、一定のサイズに達するたびに順次締め切られ（現在はおおむね1日に1回）、締め切りから14日後に削除されます。',
        '加えて、当社はお客様の同意なしに、すべてのアクセスを統計に取り込みます。その内容は、日時、アクセスされたアドレス、参照元ページ、ブラウザ、オペレーティングシステム、端末の種類、国およびネットワーク事業者、ならびにIPアドレスの代わりに、毎日新たに生成される乱数を用いて作成した値です。乱数は遅くとも2日後に削除されます。その日のログファイルも削除された時点で、当社はこれらの記録をいずれのIPアドレスとも結び付けることができなくなります。法的根拠はGDPR第6条第1項(f)です。当社の正当な利益は、リーチ測定です。統計の記録は400日後に削除されます。',
        '自動化されたアクセス（検索エンジンやAIのクローラー、スキャナー）については、本物のクローラーと偽装されたクローラーを区別し、不正利用を防ぐため、IPアドレスとそのDNS名を保存します。法的根拠はGDPR第6条第1項(f)です。当社の正当な利益は、ウェブサイトの保護です。IPアドレスとDNS名は30日後に削除されます。',
        'DNS照会のため、当社のサーバーは自社のリゾルバーに加えて、Google LLC（米国）の公開DNSサービス（Google Public DNS）を利用しています。Google LLCはEU-US Data Privacy Frameworkに基づく認証を受けており、同社への移転については欧州委員会の十分性認定があります（GDPR第45条）。また、IPアドレスのDNS名の照会は、そのアドレス範囲を管轄するネームサーバーにも届きます。これらのネームサーバーは、アドレス範囲の保有者のもとで、欧州連合の域外で運用されている場合もあります。'
      ]
    },
    {
      title: '同意とブラウザへの保存',
      paragraphs: [
        '初回の訪問時に、当社はお客様の同意をお伺いします。お客様の選択は、ランダムな同意識別子および本ポリシーの版とともに、お使いのブラウザのローカルストレージに保存します。同様に、お客様が選択した言語と、読み込まれたウェブサイトのバージョンもそこに保存します。これは、ウェブサイトの運用に厳密に必要なものです（TDDDG（ドイツ電気通信・デジタルサービスデータ保護法）第25条第2項第2号）。処理の法的根拠はGDPR第6条第1項(f)であり、当社の正当な利益は、お客様の選択を尊重する、正常に機能するウェブサイトです。これらの記録は、お客様が選択を変更するか、ブラウザのウェブサイトデータを削除するまでブラウザ内に残ります。本ポリシーが変更された場合は、改めてお伺いします。',
        'お客様の選択の証明として、当社は識別子、日時、選択内容および版を、IPアドレスを含めずに当社側で保存します。法的根拠は、GDPR第6条第1項(c)（第7条第1項との関連において）です。この証明は3年後に削除されます。',
        'お客様は、各ページ下部の「Cookie設定」から、いつでも将来に向かって同意を撤回または変更することができます。撤回前に行われた処理の適法性は、撤回によって影響を受けません。撤回により、当社が保有するお客様の訪問者プロファイルは削除されます。'
      ]
    },
    {
      title: '統計（同意がある場合）',
      paragraphs: [
        '「統計」に同意いただいた場合、ページの切り替え時およびページを離れる際に、お使いのブラウザは当社のサーバーに短いメッセージを送信します。その内容は、閲覧したページ、言語、参照元ページ、キャンペーンパラメータ（UTM）、ウィンドウサイズ、滞在時間、スクロールの深さ、ならびにお問い合わせ用リンクおよびアクション用リンクのクリックです。その際、永続的な識別子は設定されず、お客様のIPアドレスも統計には保存されません。',
        '目的は、当社ウェブサイトの利用状況を分析し、改善することです。法的根拠は、GDPR第6条第1項(a)およびTDDDG第25条第1項です。これらのメッセージは、その他の統計の記録と同様に日次の値とともに保存されます。その日のログファイルが削除された時点で、メッセージはいずれのIPアドレスとも結び付けられなくなります。メッセージは400日後に削除されます。'
      ]
    },
    {
      title: '分析と機械学習（同意がある場合）',
      paragraphs: [
        '「分析と機械学習」に同意いただいた場合、当社は再訪問を認識するために、お使いのブラウザのローカルストレージにランダムな訪問者識別子を追加で保存し、訪問者プロファイルを管理します。このプロファイルには、お客様のIPアドレスと、そこから導き出される次の情報が含まれます。すなわち、当社のサーバー上で運用しているDB-IPのデータベースによるおおよその所在地（国、地域、都市）、ネットワーク事業者および自律システム、アドレスのDNS名、ならびに地域インターネットレジストリの公開登録簿に登録されているアドレス範囲の保有者（企業、高等教育機関、官公庁など）です。これらの導き出される情報は、お客様から収集するものではなく、一般に公開されている情報源、すなわちDB-IP Liteのデータベース、ドメインネームシステム（Domain Name System）および地域インターネットレジストリの登録簿に由来します。',
        'さらに、このプロファイルには、お使いの端末およびブラウザの特性（プラットフォームとオペレーティングシステム、ブラウザ、画面サイズとウィンドウサイズ、ピクセル密度、タイムゾーン、優先言語、プロセッサのコア数、メモリ容量の区分、グラフィックスレンダラー、タッチ操作への対応、プラグインの数、Cookieが許可されているかどうか、「Do Not Track」と「Global Privacy Control」の設定、ブラウザの自動化フラグ）、お客様の操作回数（マウス、タッチ、スクロール、キーボード。入力内容は含みません）、ならびにページ、日時、滞在時間、スクロールの深さ、クリック、参照元ページおよびキャンペーンパラメータを含むお客様の訪問が含まれます。これらに基づき、ページにアクセスしているのが人間かボットかを自動的に評価します。',
        '目的は、機械学習の手法を用いて訪問統計を分析することです。すなわち、当社のウェブサイトおよび提供サービスがどのように作用し、どのような関心を集めているかを理解して両者を改善すること、ならびに人間と自動化されたアクセスを区別することです。法的根拠は、GDPR第6条第1項(a)およびTDDDG第25条第1項です。',
        '保存期間：訪問者識別子は、お客様が同意を撤回する（その場合は削除されます）か、ブラウザのウェブサイトデータを削除するまで、ブラウザ内に残ります。訪問者プロファイルは、最後の訪問から12か月後に削除され、同意が撤回された場合は直ちに削除されます。DNSおよび登録簿への照会結果は30日後に削除されます。',
        'アドレス範囲の保有者を取得するため、当社のサーバーはRDAPプロトコルを用いて管轄のレジストリに照会します。照会先は、欧州のアドレスについてはアムステルダムのRIPE NCC、その他の地域のアドレスについてはARIN（米国）、APNIC（オーストラリア）、LACNIC（ウルグアイ）またはAFRINIC（モーリシャス）です。その際、IPアドレスがこれらの機関に送信されます。ウルグアイについては、欧州委員会による十分性認定があります。米国、オーストラリアおよびモーリシャスについては、この移転に関する十分性認定がなく、GDPR第46条に基づく適切な保護措置もありません。そのため、現地の当局がデータにアクセスし、お客様がご自身の権利を行使することがより困難になるおそれがあります。これらの国への移転は、お客様の明示的な同意に基づいています（GDPR第49条第1項(a)）。この同意は、同意ダイアログにおいてこのリスクを示したうえでお願いしています。'
      ]
    },
    {
      title: 'ログインとアプリケーション',
      paragraphs: [
        '当社のアプリケーションを利用するには、アカウントを作成していただきます。その際、ユーザー名、メールアドレス、任意で入力された氏名、およびパスワードを処理します。パスワードは暗号学的ハッシュ値としてのみ保存されます。メールアドレスの確認のため、当社からお客様にメールを送信します。ログインとアカウントは当社のサーバー上で管理されます。法的根拠はGDPR第6条第1項(b)（利用契約の履行）です。',
        'ログイン中のセッションには、ログインに厳密に必要なCookieを設定します（TDDDG第25条第2項第2号）。処理の法的根拠はGDPR第6条第1項(b)です。これらのCookieは、ログアウト時またはセッションの終了時に削除され、遅くとも7日後には削除されます。',
        'アプリケーション内では、お客様が入力または連携したデータ、特に設定、チャット履歴、および連携したサービスのアクセス認証情報を処理します。アクセス認証情報は暗号化して保存します。お客様が第三者サービスのアカウント（例えば銀行口座や証券口座）を連携した場合、当社はお客様の依頼に基づき、アクセス認証情報および注文をそのサービスに送信します。法的根拠はGDPR第6条第1項(b)です。',
        'チャットでの入力内容は、回答を生成するため、OpenRouter, Inc.（米国）のサービスを経由して、その都度使用される言語モデルに転送します。OpenRouter, Inc.は当社の処理者として活動しており、同社のデータ処理契約は同社の利用規約の一部となっています。米国への移転は、欧州委員会の標準契約条項に基づいています（GDPR第46条第2項(c)）。標準契約条項は、OpenRouter, Inc.のプライバシーに関する案内（openrouter.ai/privacy）から閲覧できます。法的根拠はGDPR第6条第1項(b)です。',
        '保存期間：アカウントデータおよびアプリケーションデータは、お客様のアカウントが存在する限り保存します。アカウントの削除後は、法令上の保存義務がない限り、30日以内にこれらを削除します。'
      ]
    },
    {
      title: 'お問い合わせ',
      paragraphs: [
        'メールでお問い合わせいただいた場合、当社はお問い合わせへの対応のため、お客様が提供した情報、特にメールアドレス、メッセージの内容、および任意で提供された連絡先情報を処理します。法的根拠は、お問い合わせが見積もりまたは契約に関するものである場合はGDPR第6条第1項(b)、それ以外の場合はGDPR第6条第1項(f)です。当社の正当な利益は、お客様のお問い合わせに回答することです。',
        '当社は、お問い合わせへの対応が完了してから6か月後に、そのお問い合わせを削除します。お問い合わせが契約に至った場合は、商業書簡または業務書簡として、その暦年の末日から6年間保管します（HGB（ドイツ商法典）第257条、AO（ドイツ租税通則法）第147条）。その法的根拠はGDPR第6条第1項(c)です。'
      ]
    },
    {
      title: 'Kyveilと個人データの匿名化',
      paragraphs: [
        'Kyveilは、本ウェブサイト上で製品として紹介されています。本ウェブサイト自体は、個人データの匿名化のためにアップロードされた文書を処理しません。'
      ]
    },
    {
      title: 'ダウンロード',
      paragraphs: [
        'ダウンロードファイルは、当社のサーバーから配信されます。ダウンロードの際には、通常の技術的なアクセスデータが発生します。これらは、その他のログファイルと同様にGDPR第6条第1項(f)に基づいて処理され、ログファイルの締め切りから14日後に削除されます。'
      ]
    },
    {
      title: '提供の義務',
      paragraphs: [
        '個人データの提供は、法令上義務付けられていません。技術的に送信されるアクセスデータがなければ、ウェブサイトを配信することはできません。ユーザー名、メールアドレスおよびパスワードは利用契約の締結に必要であり、これらがなければ当社はアカウントを作成できません。すべての同意は任意であり、同意がなくてもウェブサイトは制限なくご利用いただけます。'
      ]
    },
    {
      title: '自動化された意思決定',
      paragraphs: [
        'ここに記載したいずれの処理においても、お客様に対して法的効果を生じさせる、または同様にお客様に重大な影響を及ぼす、専ら自動化された処理に基づく決定（GDPR第22条）は行われません。'
      ]
    },
    {
      title: 'お客様の権利',
      paragraphs: [
        'お客様は、法令上の要件に従い、アクセス権（GDPR第15条）、訂正の権利（GDPR第16条）、消去の権利（GDPR第17条）、処理の制限の権利（GDPR第18条）およびデータポータビリティの権利（GDPR第20条）、GDPR第21条に基づく異議を述べる権利（下記の別項を参照）、ならびにいつでも将来に向かって同意を撤回する権利（GDPR第7条第3項）を有します。',
        'また、お客様はデータ保護監督機関に苦情を申し立てる権利を有します（GDPR第77条）。当社を管轄する監督機関は、Berliner Beauftragte für Datenschutz und Informationsfreiheit（ベルリン州データ保護・情報自由監察官、所在地：Alt-Moabit 59–61, 10555 Berlin）です。'
      ]
    },
    {
      title: 'GDPR第21条に基づく異議を述べる権利',
      paragraphs: [
        '当社がGDPR第6条第1項(f)に基づいてお客様のデータを処理している場合、お客様は、ご自身の特別な状況に関する理由により、いつでもその処理に対して異議を述べる権利を有します。その場合、当社はそのデータをもはや処理しません。ただし、お客様の利益、権利および自由に優先する、処理のためのやむを得ない正当な根拠を当社が証明できる場合、または処理が法的主張の立証、行使もしくは防御のために行われる場合は、この限りではありません。',
        '異議は所定の形式によらず申し立てることができ、最も簡単な方法はinfo@paioneer.eu宛てのメールです。'
      ]
    }
  ],
  contact: {
    title: 'データ保護に関するお問い合わせ',
    description: 'データ保護に関するご質問やお客様の権利の行使については、メールでご連絡ください。',
    email: 'info@paioneer.eu'
  },
  lastUpdated: '2026年10月30日現在。ドイツ語版が正本となります。'
};
